import { observable, action, reaction, makeObservable } from 'mobx';
import { Disposer } from '../../custom_shared/misc';
import { StaticSourceModel, SourceModelBase } from '../models';
import SessionStore from './SessionStore';
import { DataCrafterSource } from '../types';

export const DATA_CRAFTER_TEMPLATE_SOURCE = 'data_crafter_templates';

export default class SourceStore extends Disposer {
    sources: SourceModelBase[] = [];

    constructor(private readonly sessionStore: SessionStore) {
        super();

        makeObservable(this, {
            sources: observable,
            createSources: action
        });

        this.reactions.push(
            reaction(
                () => this.sessionStore.response,
                () => {
                    if (!this.sessionStore.inProgress) {
                        this.createSources();
                    }
                }
            )
        );
    }

    createSources() {
        if (!this.sessionStore.response) {
            return;
        }

        this.sources = this.sessionStore.response.sources.map(source => {
            return new StaticSourceModel(source as DataCrafterSource);
        });
    }

    getSourceOptions(sourceId: string) {
        return this.sources.find(source => source.id === sourceId)?.getSourceOptions();
    }

    dispose() {
        this.disposeReactions();
    }
}
